import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
import MasterCard from "examples/Cards/MasterCard";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import DataTable from "examples/Tables/DataTable";

import { getPaymentInfo } from "actions/infoActions";
import { getOrderList, getOrderStats } from "actions/orderActions";
import MDButton from "components/MDButton";

function Orders() {
  const dispatch = useDispatch();
  const [currentInfo, setCurrentInfo] = useState(null);

  const paymentInfo = useSelector((state) => state.paymentInfo);
  const { info } = paymentInfo;

  const statsOrders = useSelector((state) => state.statsOrders);
  const { ordersStats } = statsOrders;

  const listOrders = useSelector((state) => state.listOrders);
  const { ordersList } = listOrders;

  useEffect(() => {
    if (ordersList?.length === 0) {
      dispatch(getOrderList());
    }
  }, [dispatch, ordersList?.length]);

  useEffect(() => {
    if (ordersStats?.length === 0) {
      dispatch(getOrderStats());
    }
  }, [dispatch, ordersStats?.length]);

  useEffect(() => {
    // if (info) {
    dispatch(getPaymentInfo());
    // }
  }, [dispatch]);

  useEffect(() => {
    if (info?.length) {
      setCurrentInfo(info[0]);
    }
  }, [info?.length]);

  const handleCurrentInfo = (item) => {
    info?.map((val) => {
      if (val.method === item) {
        setCurrentInfo(val);
      }
    });
  };

  const Suppliers = ({ image, name, email }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDAvatar src={image} name={name} size="sm" />
      <MDBox>
        <MDTypography
          variant="button"
          fontWeight="medium"
          ml={1}
          lineHeight={1}
          sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
        >
          {name}
        </MDTypography>
        <MDBox mt={1.5}>
          <MDTypography
            variant="button"
            fontSize="small"
            ml={1}
            lineHeight={1}
            sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
          >
            {email}
          </MDTypography>
        </MDBox>
      </MDBox>
    </MDBox>
  );

  function renderRows(data) {
    const values = [];
    data?.forEach((item, index) => {
      const newElement = {
        client: (
          <Link to={`/orders/${item?._id}`}>
            <Suppliers
              key={index}
              image={item?.requestedBy?.profile_image}
              name={item?.requestedBy?.name}
              email={item?.requestedBy?.email}
            />
          </Link>
        ),
        product: (
          <MDTypography
            variant="caption"
            sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
            fontWeight="medium"
          >
            {item?.product?.productName} - {item?.product?.productNumber}
          </MDTypography>
        ),
        amount: (
          <MDTypography
            variant="caption"
            sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
            fontWeight="medium"
          >
            Ksh. {item?.computedAmount}
          </MDTypography>
        ),
        date: (
          <MDTypography
            variant="caption"
            sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
            fontWeight="medium"
          >
            {moment(item?.created_at).format("DD MMM YYYY, HH mm")}
          </MDTypography>
        ),
        status: (
          <MDBox width="8rem" textAlign="center">
            <MDBox ml={-1}>
              <MDBadge
                badgeContent={item?.status}
                color={
                  item?.status == "initiated" ||
                  item?.status == "pending payment" ||
                  item?.status == "partially paid"
                    ? "info"
                    : item?.status == "fully paid" ||
                      item?.status == "processing delivery"
                    ? "primary"
                    : item?.status == "delivered" || item?.status == "completed"
                    ? "success"
                    : item?.status == "rejected" || item?.status == "cancelled"
                    ? "dark"
                    : "light"
                }
                variant="contained"
                size="sm"
              />
            </MDBox>
          </MDBox>
        ),
      };
      values.push(newElement);
    });
    return values;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={3}>
        <MDBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <Grid container spacing={3}>
                <Grid item xs={12} xl={4}>
                  <Grid container spacing={1} mb={1}>
                    <Grid item xs={3} sm={3} md={3} lg={3}>
                      <MDButton
                        component="a"
                        href="#"
                        rel="noreferrer"
                        variant="gradient"
                        color="light"
                        sx={{ width: "100%" }}
                        onClick={() => handleCurrentInfo("MPESA")}
                      >
                        &nbsp;MPESA
                      </MDButton>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3} lg={3}>
                      <MDButton
                        component="a"
                        href="#"
                        rel="noreferrer"
                        variant="gradient"
                        color="light"
                        sx={{ width: "100%" }}
                        onClick={() => handleCurrentInfo("CHEQUE")}
                      >
                        &nbsp;CHEQUE
                      </MDButton>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3} lg={3}>
                      <MDButton
                        component="a"
                        href="#"
                        rel="noreferrer"
                        variant="gradient"
                        color="light"
                        sx={{ width: "100%" }}
                        onClick={() => handleCurrentInfo("BANK TRANSFER")}
                      >
                        &nbsp;TRANSFER
                      </MDButton>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3} lg={3}>
                      <MDButton
                        component="a"
                        href="#"
                        rel="noreferrer"
                        variant="gradient"
                        color="light"
                        sx={{ width: "100%" }}
                        onClick={() => handleCurrentInfo("FINANCING")}
                      >
                        &nbsp;CREDIT
                      </MDButton>
                    </Grid>
                  </Grid>
                  <MasterCard currentInfo={currentInfo} />
                </Grid>
                {ordersStats?.map((item, index) => (
                  <>
                    {item?.statuses?.status == "pending payment" ||
                    item?.statuses?.status == "fully paid" ||
                    item?.statuses?.status == "completed" ||
                    item?.statuses?.status == "rejected" ? (
                      <Grid key={index} item xs={12} md={2} xl={2}>
                        <DefaultInfoCard
                          icon={
                            item?.statuses?.status == "initiated"
                              ? "timer_outlined"
                              : item?.statuses?.status == "pending payment"
                              ? "priority_high"
                              : item?.statuses?.status == "partially paid"
                              ? "balance"
                              : item?.statuses?.status == "fully paid"
                              ? "price_check"
                              : item?.statuses?.status == "processing delivery"
                              ? "hourglass_bottom"
                              : item?.statuses?.status == "delivered"
                              ? "local_shipping_outlined"
                              : item?.statuses?.status == "completed"
                              ? "done"
                              : "clear"
                          }
                          title={
                            item?.statuses?.status == "initiated"
                              ? "Initiated Orders"
                              : item?.statuses?.status == "pending payment"
                              ? "Awaiting Payment"
                              : item?.statuses?.status == "partially paid"
                              ? "Partially Paid"
                              : item?.statuses?.status == "fully paid"
                              ? "Fully Paid"
                              : item?.statuses?.status == "processing delivery"
                              ? "Processing Orders"
                              : item?.statuses?.status == "delivered"
                              ? "Order Delivered"
                              : item?.statuses?.status == "completed"
                              ? "Approved Orders"
                              : "Rejected Orders"
                          }
                          color={
                            item?.statuses?.status == "initiated" ||
                            item?.statuses?.status == "pending payment" ||
                            item?.statuses?.status == "partially paid"
                              ? "info"
                              : item?.statuses?.status == "fully paid" ||
                                item?.statuses?.status == "processing delivery"
                              ? "primary"
                              : item?.statuses?.status == "delivered" ||
                                item?.statuses?.status == "completed"
                              ? "success"
                              : "dark"
                          }
                          description={
                            "Percentage: " +
                            (item?.statuses?.percentage).toFixed(1) +
                            "% of " +
                            item?.totalCount +
                            " orders"
                          }
                          value={item?.statuses?.count}
                        />
                      </Grid>
                    ) : (
                      <></>
                    )}
                  </>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </MDBox>
        <MDBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              {/* <Card id="delete-account"> */}
              <MDBox pt={3} px={2}>
                <MDTypography
                  variant="body2"
                  fontWeight="small"
                  mb={2}
                  sx={{ color: ({ palette: { text, grey } }) => text.light }}
                >
                  # To add new order, start selection from desired product.
                </MDTypography>
                <MDTypography
                  variant="h6"
                  fontWeight="medium"
                  mb={1}
                  sx={{ color: ({ palette: { text, grey } }) => text.light }}
                >
                  Orders
                </MDTypography>
              </MDBox>

              <MDBox display="flex" alignItems="center" lineHeight={0}></MDBox>
              <MDBox>
                <DataTable
                  table={{
                    columns: [
                      {
                        Header: "client",
                        accessor: "client",
                        width: "25%",
                        align: "left",
                      },
                      {
                        Header: "product",
                        accessor: "product",
                        width: "15%",
                        align: "left",
                      },

                      {
                        Header: "amount",
                        accessor: "amount",
                        width: "15%",
                        align: "left",
                      },

                      {
                        Header: "date",
                        accessor: "date",
                        width: "15%",
                        align: "left",
                      },
                      {
                        Header: "status",
                        accessor: "status",
                        width: "20%",
                        align: "center",
                      },
                    ],

                    rows: renderRows(ordersList),
                  }}
                  showTotalEntries={false}
                  isSorted={false}
                  noEndBorder
                  entriesPerPage={false}
                />
              </MDBox>
              {/* </Card> */}
            </Grid>
            {/* <Grid item xs={12} md={5}>
              <IncompleteOrders />
            </Grid> */}
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Orders;
